import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const GAMES = [
  {
    id: "quiz",
    emoji: "🧠",
    name: "Викторина",
    tier: "free",
    color: "#ff3cac",
    players: "1–8",
    time: "10–20 мин",
    short: "Отвечай на вопросы быстрее всех и набирай очки",
    how: [
      "Хост запускает игру — на экране появляется вопрос с 4 вариантами ответа",
      "У каждого игрока на телефоне те же 4 варианта — нажми на правильный",
      "На ответ есть 30 секунд, потом раунд закрывается автоматически",
      "Правильный ответ приносит 100 очков — побеждает тот у кого больше",
      "Вопросы генерирует ИИ каждый раз новые, поэтому игра не надоедает",
    ],
    tips: "Выбирай побольше раундов — 10–15 чтобы интрига сохранялась до конца",
  },
  {
    id: "drawing",
    emoji: "✏️",
    name: "Рисовалка",
    tier: "free",
    color: "#00f5ff",
    players: "2–8",
    time: "15–25 мин",
    short: "Рисуй слова и угадывай чужие рисунки",
    how: [
      "Каждый раунд один игрок становится художником — он получает слово на телефоне",
      "Художник рисует слово на своём телефоне — рисунок виден всем на хост-экране",
      "Остальные игроки пишут свои варианты — кто угадает первым получает очки",
      "Художник тоже получает очки за каждого кто угадал его рисунок",
      "Чем быстрее угадали — тем больше очков получает угадавший",
    ],
    tips: "Пробуй рисовать схематично и добавлять подсказки стрелками — это честная игра!",
  },
  {
    id: "truthdare",
    emoji: "🔥",
    name: "Правда или Действие",
    tier: "free",
    color: "#ff8c00",
    players: "2–8",
    time: "20–40 мин",
    short: "Классика на вечеринке — правда или выполни задание",
    how: [
      "Каждый раунд один игрок ход — он видит на телефоне кнопки «Правда» и «Действие»",
      "Выбрал Правду — на экране появляется личный вопрос который нужно ответить честно",
      "Выбрал Действие — задание которое нужно выполнить прямо сейчас",
      "Остальные игроки наблюдают на хост-экране и следят за выполнением",
      "Ходы чередуются по кругу — каждый получит своё",
    ],
    tips: "Лучше всего работает когда все немного знают друг друга — вопросы становятся острее",
  },
  {
    id: "crocodile",
    emoji: "🐊",
    name: "Крокодил",
    tier: "free",
    color: "#3dffa0",
    players: "2–8",
    time: "15–30 мин",
    short: "Объясняй слова жестами и мимикой без единого слова",
    how: [
      "Один игрок получает слово на телефоне — он должен объяснить его без слов",
      "Остальные пишут свои варианты — угадавший получает очки",
      "На объяснение 60 секунд — потом раунд завершается",
      "Объяснявший тоже получает очки если кто-то угадал",
      "Слова бывают простые и сложные — ИИ генерирует каждый раз новые",
    ],
    tips: "Разреши использовать звуки но не слова — так становится ещё смешнее",
  },
  {
    id: "voting",
    emoji: "🗳️",
    name: "Голосование",
    tier: "pro",
    color: "#ffe600",
    players: "3–10",
    time: "10–20 мин",
    short: "Голосуй за кого из игроков это больше всего относится",
    how: [
      "На экране появляется вопрос в стиле «Кто из игроков скорее всего забудет купить подарок?»",
      "Все одновременно голосуют на телефоне — выбирают одного из игроков",
      "После голосования хост-экран показывает кто за кого проголосовал",
      "Тот кто получил больше всего голосов становится «виновником»",
      "Очки получает тот кто угадал большинство — то есть проголосовал за победителя",
    ],
    tips: "Самая социальная игра — раскрывает что друзья реально думают друг о друге",
  },
  {
    id: "music",
    emoji: "🎵",
    name: "Угадай мелодию",
    tier: "pro",
    color: "#9b5de5",
    players: "2–8",
    time: "15–25 мин",
    short: "Слушай превью песни и угадывай исполнителя или название",
    how: [
      "На хост-экране играет фрагмент песни — 30 секунд",
      "На телефоне 4 варианта ответа — исполнитель или название",
      "Кто нажал быстрее и правильно — получает больше очков",
      "Хост может выбрать плейлист: русская музыка, 80–90е, электронная и другие",
      "Кнопка «Пропустить» у хоста позволяет перейти к следующей песне",
    ],
    tips: "Плейлист «Русские хиты» идеально заходит для смешанной компании от 20 до 40 лет",
  },
  {
    id: "reverse_music",
    emoji: "🔁",
    name: "Музыка наоборот",
    tier: "pro",
    color: "#7b3dd5",
    players: "2–8",
    time: "15–25 мин",
    short: "Угадай песню по перевёрнутому звуку",
    how: [
      "Та же механика что в Угадай мелодию — но аудио воспроизводится задом наперёд",
      "Мозг поначалу вообще не понимает что играет — но потом узнаёт",
      "Популярные песни угадываются легче — они «въелись» в память",
      "4 варианта ответа на телефоне — выбирай быстрее",
      "Можно пропустить если совсем не узнать",
    ],
    tips: "Лучше играть после обычной Угадай мелодию — контраст делает игру смешнее",
  },
  {
    id: "fast_music",
    emoji: "⚡",
    name: "Музыка на скорости",
    tier: "pro",
    color: "#FFD600",
    players: "2–8",
    time: "15–25 мин",
    short: "Угадай песню ускоренную в несколько раз",
    how: [
      "Песня играет на скорости x1.5–x2 — голоса становятся писклявыми",
      "Знакомые хиты звучат смешно и странно но всё равно узнаваемо",
      "4 варианта ответа — кто быстрее угадает",
      "Тайна успеха: ритм и мелодия сохраняются даже на высокой скорости",
    ],
    tips: "Замедленные хиты узнать проще чем ускоренные — отличная разминка",
  },
  {
    id: "quiplash",
    emoji: "💬",
    name: "Закончи фразу",
    tier: "pro",
    color: "#00DDFF",
    players: "3–8",
    time: "20–35 мин",
    short: "Придумай самый смешной конец фразы и победи голосованием",
    how: [
      "На экране незаконченная фраза — например «Самое странное что я видел в лифте: ...»",
      "Все игроки пишут свой вариант окончания на телефоне — 60 секунд",
      "Потом все варианты показываются на хост-экране анонимно",
      "Каждый голосует за самый смешной — 30 секунд на голосование",
      "Автор ответа набравшего больше всего голосов получает очки",
    ],
    tips: "Чем абсурднее ответы — тем больше смеха. Не пытайся угадать «правильный» — его нет",
  },
  {
    id: "fibbage",
    emoji: "🤥",
    name: "Фиббедж",
    tier: "pro",
    color: "#B24BF3",
    players: "2–8",
    time: "20–35 мин",
    short: "Придумай убедительную ложь чтобы обмануть других игроков",
    how: [
      "На экране необычный факт с пропуском — например «В NASA есть должность официального ___»",
      "Каждый придумывает правдоподобный ответ на телефоне — 60 секунд",
      "Потом все варианты + правильный ответ перемешиваются и показываются",
      "Голосуй за тот вариант который считаешь настоящим — 30 секунд",
      "Очки получает тот чью ложь выбрали другие — и тот кто угадал правду",
    ],
    tips: "Стиль победителя: ложь должна звучать скучно и официально как в Википедии",
  },
  {
    id: "fact_or_fake",
    emoji: "🔍",
    name: "Правда или Фейк",
    tier: "pro",
    color: "#00C9FF",
    players: "2–8",
    time: "10–20 мин",
    short: "Определи — это реальный факт или выдумка?",
    how: [
      "На экране утверждение — например «Коровы дают больше молока когда слушают музыку»",
      "На телефоне две кнопки: ✅ Правда и ❌ Фейк",
      "Отвечай быстро — чем быстрее правильный ответ тем больше очков",
      "После ответа всех показывается объяснение — почему это правда или ложь",
      "Факты часто неожиданные — готовься удивляться",
    ],
    tips: "Если не знаешь — доверяй интуиции. Статистически первый импульс чаще правильный",
  },
  {
    id: "emoji_movie",
    emoji: "🎬",
    name: "Фильм по эмодзи",
    tier: "pro",
    color: "#FF6B35",
    players: "2–8",
    time: "10–20 мин",
    short: "Угадай фильм закодированный в эмодзи",
    how: [
      "На хост-экране набор эмодзи — например 🦁👑🌍 это «Король Лев»",
      "На телефоне 4 варианта названий фильмов — выбери правильный",
      "30 секунд на раздумье — кто быстрее получает больше очков",
      "Загадки бывают простые и очень хитрые — некоторые заставят реально думать",
    ],
    tips: "Смотри на эмодзи как на сцены или символы фильма, не буквально",
  },
  {
    id: "two_truths",
    emoji: "🤥",
    name: "Два правды одна ложь",
    tier: "pro",
    color: "#B24BF3",
    players: "3–10",
    time: "15–30 мин",
    short: "Угадай какое из трёх утверждений про игрока — ложь",
    how: [
      "Каждый раунд один игрок пишет три факта о себе — два правдивых и одну ложь",
      "Все три показываются на хост-экране перемешанными",
      "Остальные голосуют — какое утверждение выдуманное",
      "Автор получает очки за каждого кто не угадал ложь",
      "Угадавшие тоже получают очки",
    ],
    tips: "Делай ложь правдоподобной — придумай детали которые звучат реалистично",
  },
  {
    id: "dictator",
    emoji: "👑",
    name: "Диктатор",
    tier: "pro",
    color: "#FFD700",
    players: "3–10",
    time: "20–35 мин",
    short: "Диктатор издаёт абсурдный закон — все голосуют принять или свергнуть",
    how: [
      "Один игрок становится Диктатором — он получает тему на телефоне",
      "Диктатор придумывает и вводит абсурдный закон — например «Все должны говорить только шёпотом»",
      "Остальные обсуждают 30 секунд и голосуют: поддержать или свергнуть диктатора",
      "Если большинство за — закон принят и диктатор получает очки",
      "Если большинство против — диктатор свергнут и теряет очки",
    ],
    tips: "Самые смешные законы — те что создают неудобства но выполнимы прямо сейчас",
  },
  {
    id: "bumper",
    emoji: "🚗",
    name: "Бамперные машинки",
    tier: "pro",
    color: "#ff3355",
    players: "2–6",
    time: "10–20 мин",
    short: "Управляй машинкой и врезайся в других — кто выживет дольше",
    how: [
      "На хост-экране арена с машинками всех игроков",
      "На телефоне джойстик — тяни в любую сторону чтобы двигаться",
      "Врезайся в других — чем больше урона нанесёшь тем больше очков",
      "У каждой машинки здоровье — кто потеряет все HP выбывает",
      "Последний выживший получает бонус",
    ],
    tips: "Держись у краёв арены — там меньше столкновений и проще уворачиваться",
  },
  {
    id: "wheelword",
    emoji: "🎡",
    name: "Поле чудес",
    tier: "pro",
    color: "#FF6B6B",
    players: "2–8",
    time: "20–35 мин",
    short: "Крути барабан и угадывай буквы в слове",
    how: [
      "На хост-экране загадано слово — открыты только некоторые буквы",
      "Каждый ход игрок крутит барабан — выпадает сумма очков",
      "Называй букву: если есть в слове — получаешь очки × количество букв",
      "Можно попробовать угадать слово целиком — это рискованно но выгодно",
      "Можно купить гласную за фиксированную цену вместо кручения",
    ],
    tips: "Сначала называй самые частые согласные: Н, Т, Р, С — они чаще всего в словах",
  },
  {
    id: "sniper",
    emoji: "🎯",
    name: "Снайпер",
    tier: "pro",
    color: "#ff3355",
    players: "2–8",
    time: "10–20 мин",
    short: "Нажми точно в момент когда прицел в зоне",
    how: [
      "На телефоне бегущий прицел и зелёная зона попадания",
      "Нажми кнопку пока прицел находится в зоне — чем точнее тем больше очков",
      "С каждым раундом зона сужается — становится всё сложнее",
      "Промахнулся — теряешь жизнь. Потерял все — вылетел",
      "Побеждает тот кто выживет дольше всех",
    ],
    tips: "Не смотри на прицел — смотри на зону. Нажимай чуть раньше чем думаешь нужно",
  },
  {
    id: "taprace",
    emoji: "🏎️",
    name: "Гонка на тапах",
    tier: "pro",
    color: "#ff8c00",
    players: "2–8",
    time: "10–20 мин",
    short: "Тапай как можно быстрее чтобы машинка ехала",
    how: [
      "На хост-экране трасса и машинки всех игроков",
      "На телефоне большая кнопка — чем быстрее тапаешь тем быстрее едет машинка",
      "Первый пересёкший финиш побеждает в раунде",
      "Комбо-множитель: серия быстрых тапов увеличивает скорость в 2–3 раза",
      "5 раундов — у кого больше побед в раундах тот победитель",
    ],
    tips: "Держи телефон двумя руками и тапай двумя большими пальцами поочерёдно — это быстрее",
  },
  {
    id: "simon",
    emoji: "⚡",
    name: "Повтори комбо",
    tier: "pro",
    color: "#9b5de5",
    players: "2–8",
    time: "10–20 мин",
    short: "Запомни и повтори последовательность цветов",
    how: [
      "На хост-экране 4 цветные кнопки мигают в определённом порядке",
      "Нужно повторить ту же последовательность на телефоне",
      "С каждым раундом последовательность длиннее на один цвет",
      "Ошибся — выбываешь из раунда",
      "Чем дольше продержался — тем больше очков",
    ],
    tips: "Проговаривай цвета вслух пока смотришь — слуховая память помогает лучше запомнить",
  },
  {
    id: "stroop",
    emoji: "👁️",
    name: "Не верь словам",
    tier: "pro",
    color: "#A0FF00",
    players: "2–8",
    time: "10–15 мин",
    short: "Нажми кнопку по ЦВЕТУ текста, а не по слову",
    how: [
      "На экране слово — например «КРАСНЫЙ» — но написано синим цветом",
      "Нужно нажать кнопку по ЦВЕТУ текста — то есть синюю",
      "Мозг автоматически читает слово и путается — это называется эффект Струпа",
      "4 секунды на ответ — потом раунд закрывается",
      "Неверный ответ = потеря жизни. Потерял все — выбыл",
    ],
    tips: "Пробуй смотреть «сквозь» текст на его цвет — не читай, просто смотри на краску",
  },
  {
    id: "flappy",
    emoji: "🐦",
    name: "Птичий забег",
    tier: "pro",
    color: "#6BCB77",
    players: "2–6",
    time: "10–20 мин",
    short: "Тапай чтобы птичка летела и не врезалась в трубы",
    how: [
      "Игра идёт прямо на телефоне — у каждого своя птичка",
      "Тапай по экрану — птичка взмахивает крыльями и летит вверх",
      "Не тапаешь — птичка падает вниз под действием гравитации",
      "Нужно пролетать между трубами не задевая их",
      "Хост-экран показывает всех птичек одновременно как зрелищный вид",
      "Кто пролетел больше труб — тот победил",
    ],
    tips: "Короткие частые тапы лучше редких сильных — держи птичку в середине экрана",
  },
  {
    id: "quest",
    emoji: "🔍",
    name: "Квест",
    tier: "pro",
    color: "#4a90d9",
    players: "2–10",
    time: "20–40 мин",
    short: "Командное приключение с развилками и голосованием",
    how: [
      "На хост-экране сцена квеста с текстом и картинкой",
      "Каждый игрок голосует за один из вариантов действий на телефоне",
      "После 45 секунд или когда все проголосовали — история идёт по пути большинства",
      "Выборы влияют на концовку — у квеста несколько финалов",
      "В конце все получают очки в зависимости от того насколько хорошей была концовка",
    ],
    tips: "Обсуждайте вслух перед голосованием — это командная игра, не индивидуальная",
  },
  {
    id: "jeopardy",
    emoji: "🏆",
    name: "Своя игра",
    tier: "pro",
    color: "#FFD700",
    players: "2–8",
    time: "20–40 мин",
    short: "Таблица категорий и очков — выбирай вопрос, жми кнопку и вводи ответ",
    how: [
      "На телефоне таблица: 5 категорий × 5 стоимостей (100–500 очков)",
      "Игроки ходят по очереди — у кого ход, тот выбирает клетку",
      "Вопрос появляется у всех — кто знает ответ жмёт красную кнопку 🔔",
      "Нажавший первым вводит ответ текстом на своём телефоне — 20 секунд",
      "Система проверяет автоматически: верно — +очки, неверно — −очки и другие могут нажать",
      "Если никто не угадал — хост может нажать «Раскрыть ответ» (0 очков)",
      "Остальные игроки видят правильный ответ на своих телефонах пока кто-то отвечает",
    ],
    tips: "Отвечай уверенно — неверный ответ штрафует. Если сомневаешься — дай другим шанс нажать кнопку",
  },
  {
    id: "reaction",
    emoji: "⚡",
    name: "Реакция",
    tier: "free",
    color: "#00f5ff",
    players: "2–8",
    time: "10–15 мин",
    short: "Жди сигнала и нажми первым — но не попадись на ловушку",
    how: [
      "На хост-экране большой круг — серый пока идёт ожидание",
      "Через случайное время (2–5 сек) круг меняет цвет",
      "Зелёный — жми на телефоне как можно быстрее!",
      "Красный — ловушка! Кто нажмёт — теряет 300 очков",
      "Нажал до сигнала — фальстарт, штраф 200 очков",
      "Чем быстрее реакция на зелёный — тем больше очков (до 1000)",
    ],
    tips: "Не смотри на телефон — смотри на хост-экран. Держи палец над кнопкой но не жми заранее",
  },
  {
    id: "puzzle_music",
    emoji: "🧩",
    name: "Музыкальный пазл",
    tier: "pro",
    color: "#C77DFF",
    players: "2–8",
    time: "15–25 мин",
    short: "Угадай песню по коротким отрывкам — каждый раунд звучит всё чётче",
    how: [
      "Хост-экран воспроизводит 4 отрывка по 2 секунды с паузой 4 секунды между ними",
      "После каждого отрывка можно нажать ответ на телефоне — не обязательно ждать все 4",
      "Чем раньше угадаешь — тем больше очков получишь",
      "4 варианта ответа на телефоне — исполнитель или название",
      "Хост может выбрать плейлист перед игрой: русские хиты, 80–90е и другие",
    ],
    tips: "Угадывай после первого отрывка если узнал — это даёт максимум очков",
  },
  {
    id: "cars",
    emoji: "🏎️",
    name: "Угадай марку",
    tier: "free",
    color: "#FF6B00",
    players: "1–8",
    time: "10–20 мин",
    short: "Угадай марку автомобиля по пикселизованному логотипу",
    how: [
      "На хост-экране появляется логотип автомобильной марки — сначала очень пикселизованный",
      "Каждые 4 секунды изображение становится чётче — пока не откроется полностью",
      "На телефоне 4 варианта ответа — нажми правильный как можно быстрее",
      "Кто угадал раньше — тот получает больше очков",
      "50 марок в базе — от BMW и Toyota до редких Bugatti и Rivian",
    ],
    tips: "Смотри на форму и цвет логотипа ещё на первом кадре — очертания часто узнаваемы",
  },
  {
    id: "quiz_cinema",
    emoji: "🎬",
    name: "Кино-викторина",
    tier: "pro",
    color: "#E040FB",
    players: "1–8",
    time: "10–20 мин",
    short: "Вопросы про фильмы, актёров, режиссёров и киноиндустрию",
    how: [
      "На хост-экране появляется вопрос о кино с 4 вариантами ответа",
      "Выбери правильный на своём телефоне — у тебя 30 секунд",
      "Правильный ответ приносит 100 очков — побеждает тот у кого больше",
      "Вопросы от классики до современных блокбастеров",
      "Подходит для киноманов и всех кто смотрит хоть иногда",
    ],
    tips: "Если не знаешь точно — исключай явно неверные варианты, часто помогает",
  },
  {
    id: "quiz_18",
    emoji: "🔞",
    name: "Викторина 18+",
    tier: "pro",
    color: "#FF1744",
    players: "1–8",
    time: "10–20 мин",
    short: "Острые, смешные и откровенные вопросы только для взрослых",
    how: [
      "Те же правила что в обычной викторине — вопрос и 4 варианта",
      "Выбери правильный на телефоне за 30 секунд",
      "Правильный ответ приносит 100 очков",
      "Вопросы острые и откровенные — только для компании 18+",
      "Отличный вариант для вечеринки когда дети уже спят",
    ],
    tips: "Не принимай близко к сердцу — здесь главное веселье, а не эрудиция",
  },
  {
    id: "quiz_movies",
    emoji: "🍿",
    name: "Угадай фильм",
    tier: "pro",
    color: "#FF6B35",
    players: "1–8",
    time: "10–20 мин",
    short: "Угадывай фильмы и сериалы по описанию, цитатам и подсказкам",
    how: [
      "На экране появляется описание или цитата из фильма — с 4 вариантами",
      "Выбери правильный на телефоне за 30 секунд",
      "100 очков за правильный ответ, побеждает набравший больше всех",
      "Фильмы самых разных жанров — от комедий до триллеров",
      "Чем больше смотришь кино тем лучше результат",
    ],
    tips: "Обращай внимание на детали в описании — там часто спрятана подсказка",
  },
  {
    id: "lexicon",
    emoji: "📖",
    name: "Значения слов",
    tier: "pro",
    color: "#4FC3F7",
    players: "1–8",
    time: "10–20 мин",
    short: "Угадай значение редкого или сложного слова из 4 вариантов",
    how: [
      "На хост-экране появляется слово и 4 варианта его значения",
      "Выбери правильный ответ на своём телефоне — у тебя 30 секунд",
      "Правильный ответ приносит 100 очков — побеждает тот у кого больше",
      "Слова редкие и каверзные — даже знатоки русского часто ошибаются",
      "После каждого раунда видно кто ответил правильно",
    ],
    tips: "Если не знаешь слово — исключай явно неподходящие варианты, часто помогает",
  },
  {
    id: "screenplay",
    emoji: "🎬",
    name: "Безумный сценарист",
    tier: "pro",
    color: "#FF6B35",
    players: "2–10",
    time: "15–25 мин",
    short: "Вместе строим безумную историю — голосуете за лучший вариант каждой части",
    how: [
      "Каждый раунд — один вопрос: кто герой, где действие, что пошло не так и т.д.",
      "Все игроки видят одинаковые 4 варианта ответа на своих телефонах",
      "Все голосуют одновременно — вариант с большинством попадает в историю",
      "Всего 8 фаз — герой, место, завязка, злодей, план, поворот, помощник, финал",
      "В конце история зачитывается целиком и озвучивается — обычно это чистый угар",
    ],
    tips: "Чем больше народу тем смешнее — при 8 игроках голосование само по себе ржачное",
  },
  {
    id: "spyfall",
    emoji: "🕵️",
    name: "Шпион",
    tier: "pro",
    color: "#7b3dd5",
    players: "4–16",
    time: "20–40 мин",
    short: "Один из вас шпион — остальные знают локацию, а он нет. Вычислите его!",
    how: [
      "В начале каждого раунда все игроки узнают локацию (больница, космический корабль...) — кроме одного: шпиона",
      "Шпион видит только '🕵️ ТЫ ШПИОН!' — он должен угадать локацию по ответам",
      "Игроки по очереди задают друг другу вопросы из предложенных вариантов",
      "Отвечающий видит описание локации как подсказку — но должен отвечать уклончиво",
      "После всех вопросов — 15 секунд обсуждения, потом голосование за шпиона",
      "Если шпиона поймали — мирные побеждают. Если нет — шпион угадывает локацию из 6 вариантов",
    ],
    tips: "Шпион может нажать 'Я знаю где я!' во время обсуждения — если угадает, получит +300 вместо +200, но провал означает немедленное поражение",
  },
];

const TIER_LABEL = { free: "🆓 Бесплатно", pro: "🔒 PRO" };
const TIER_COLOR = { free: "#3dffa0", pro: "#9b5de5" };

export default function HowToPlayPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("all");
  const detailRef = useRef(null); // all | free | pro

  const filtered = GAMES.filter(g => filter === "all" || g.tier === filter);
  const active = selected ? GAMES.find(g => g.id === selected) : null;

  return (
    <div className="min-h-screen bg-cartoon stars-bg" style={{ color: "#fff" }}>
      <Navbar />

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "2rem 1rem 5rem" }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(2rem, 6vw, 3.5rem)",
            color: "#fff", textShadow: "3px 3px 0 #ff3cac, 6px 6px 0 #000",
            marginBottom: "0.5rem",
          }}>
            КАК ИГРАТЬ
          </h1>
          <p style={{ fontFamily: "'Nunito', sans-serif", color: "#aaa", fontSize: "1rem" }}>
            Нажми на любую игру чтобы узнать механику подробно
          </p>
        </div>

        {/* Фильтр */}
        <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: "1.5rem", flexWrap: "wrap" }}>
          {[["all", "Все игры"], ["free", "🆓 Бесплатные"], ["pro", "🔒 PRO"]].map(([val, label]) => (
            <button key={val} onClick={() => setFilter(val)} style={{
              fontFamily: "'Fredoka One', sans-serif", fontSize: "0.95rem",
              padding: "0.4rem 1.1rem", borderRadius: "2rem", cursor: "pointer",
              background: filter === val ? "#ff3cac" : "#ffffff0d",
              color: filter === val ? "#fff" : "#aaa",
              border: `2px solid ${filter === val ? "#ff3cac" : "#ffffff15"}`,
              boxShadow: filter === val ? "3px 3px 0 #000" : "none",
              transition: "all 0.15s",
            }}>{label}</button>
          ))}
        </div>

        {/* Список игр */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
          gap: 10, marginBottom: "2rem",
        }}>
          {filtered.map(g => (
            <button
              key={g.id}
              onClick={() => { setSelected(selected === g.id ? null : g.id); if (selected !== g.id) setTimeout(() => detailRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); }}
              style={{
                background: selected === g.id ? g.color + "22" : "#ffffff08",
                border: `2.5px solid ${selected === g.id ? g.color : "#ffffff15"}`,
                borderRadius: "1rem", padding: "0.75rem 0.5rem",
                cursor: "pointer", textAlign: "center",
                boxShadow: selected === g.id ? `4px 4px 0 #000` : "none",
                transform: selected === g.id ? "translate(-2px,-2px)" : "none",
                transition: "all 0.15s",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <div style={{ fontSize: "2rem", marginBottom: 4 }}>{g.emoji}</div>
              <div style={{
                fontFamily: "'Fredoka One', sans-serif", fontSize: "0.9rem",
                color: selected === g.id ? g.color : "#ddd", lineHeight: 1.2,
              }}>{g.name}</div>
              <div style={{
                fontFamily: "'Nunito', sans-serif", fontSize: "0.65rem",
                color: TIER_COLOR[g.tier], marginTop: 4,
              }}>{TIER_LABEL[g.tier]}</div>
            </button>
          ))}
        </div>

        {/* Детальная карточка */}
        {active && (
          <div ref={detailRef} style={{
            background: active.color + "12",
            border: `3px solid ${active.color}55`,
            borderRadius: "1.5rem", boxShadow: "6px 6px 0 #000",
            padding: "1.5rem", marginBottom: "2rem",
            animation: "slideUp 0.2s ease",
          }}>
            {/* Заголовок */}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.25rem", flexWrap: "wrap" }}>
              <span style={{ fontSize: "3rem" }}>{active.emoji}</span>
              <div>
                <h2 style={{
                  fontFamily: "'Fredoka One', sans-serif", fontSize: "1.8rem",
                  color: active.color, textShadow: "2px 2px 0 #000", margin: 0,
                }}>{active.name}</h2>
                <div style={{ display: "flex", gap: 8, marginTop: 4, flexWrap: "wrap" }}>
                  <span style={{
                    fontFamily: "'Nunito', sans-serif", fontSize: "0.75rem",
                    background: "#ffffff10", border: "1px solid #ffffff20",
                    borderRadius: "2rem", padding: "2px 8px", color: "#aaa",
                  }}>👥 {active.players} игроков</span>
                  <span style={{
                    fontFamily: "'Nunito', sans-serif", fontSize: "0.75rem",
                    background: "#ffffff10", border: "1px solid #ffffff20",
                    borderRadius: "2rem", padding: "2px 8px", color: "#aaa",
                  }}>⏱ {active.time}</span>
                  <span style={{
                    fontFamily: "'Nunito', sans-serif", fontSize: "0.75rem",
                    background: TIER_COLOR[active.tier] + "22",
                    border: `1px solid ${TIER_COLOR[active.tier]}55`,
                    borderRadius: "2rem", padding: "2px 8px",
                    color: TIER_COLOR[active.tier],
                  }}>{TIER_LABEL[active.tier]}</span>
                </div>
              </div>
            </div>

            <p style={{
              fontFamily: "'Nunito', sans-serif", fontSize: "1rem",
              color: "#ddd", marginBottom: "1.25rem", lineHeight: 1.6,
            }}>{active.short}</p>

            {/* Механика */}
            <h3 style={{
              fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem",
              color: "#fff", marginBottom: "0.75rem",
            }}>📋 Как играть:</h3>
            <ol style={{ paddingLeft: "1.2rem", margin: "0 0 1.25rem" }}>
              {active.how.map((step, i) => (
                <li key={i} style={{
                  fontFamily: "'Nunito', sans-serif", fontSize: "0.92rem",
                  color: "#ccc", lineHeight: 1.6, marginBottom: "0.4rem",
                }}>{step}</li>
              ))}
            </ol>

            {/* Совет */}
            <div style={{
              background: "#ffe60015", border: "2px solid #ffe60033",
              borderRadius: "0.75rem", padding: "0.75rem 1rem",
            }}>
              <span style={{ fontFamily: "'Fredoka One', sans-serif", color: "#ffe600", fontSize: "0.95rem" }}>
                💡 Совет:
              </span>
              <span style={{ fontFamily: "'Nunito', sans-serif", color: "#ccc", fontSize: "0.88rem", marginLeft: 8 }}>
                {active.tips}
              </span>
            </div>
          </div>
        )}

        {/* Нижний CTA */}
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <button
            onClick={() => navigate("/games")}
            style={{
              fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem",
              background: "#ff3cac", color: "#fff",
              border: "3px solid #000", borderRadius: "1rem",
              boxShadow: "4px 4px 0 #000", padding: "0.75rem 2rem",
              cursor: "pointer", transition: "transform 0.1s",
            }}
            onMouseEnter={e => e.currentTarget.style.transform = "translate(-2px,-2px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "none"}
          >
            🎮 Начать играть!
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}